import React, { useEffect, useState } from "react";
import Trombinoscope from "../components/Trombinoscope";
import AdhesionForm from "../components/AdhesionForm";
import Footer from "../components/Footer";
import HeaderHomeAdmin from "../headers/headerHomeAdmin";
import { Modal, Button } from "react-bootstrap";
import * as API from "../services/API";
import ErrorModal from "../components/ErrorModal";
import SuccessToast from "../components/SuccessToast";

const MyModal = ({ onClose,onAdd,trombi = null }) => {
	const [first_name, setFirstname] = useState(trombi?trombi.first_name:null);
	const [last_name, setLastname] = useState(trombi?trombi.last_name:null);
	const [email, setEmail] = useState(trombi?trombi.email:null);
	const [phone, setPhone] = useState(trombi?trombi.phone:null);
	const [job, setJob] = useState(trombi?trombi.job:null);
	const [id_image, setId_image] = useState(trombi?trombi.id_image:null);
    const [extension, setExtension] = useState("");
    const [errors, setErrors] = useState({});
    const isFormComplete =
        Boolean(last_name?.trim()) &&
        Boolean(first_name?.trim()) &&
        Boolean(email?.trim()) &&
        Boolean(job?.trim()) &&
        Boolean(id_image);

    const validate = () => {
        const newErrors = {};

        if (!last_name?.trim()) newErrors.last_name = "Le nom est obligatoire";
        if (!first_name?.trim()) newErrors.first_name = "Le prénom est obligatoire";

        // Email basique
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email?.trim()) newErrors.email = "L'email est obligatoire";
        else if (!emailRegex.test(email)) newErrors.email = "Format d'email invalide";

        if (phone?.trim()) {
        const phoneRegex = /^(\d{10}|\d{2} \d{2} \d{2} \d{2} \d{2})$/;
        if (!phoneRegex.test(phone))
            newErrors.phone = "Format téléphone invalide (ex: 0612345678 ou 06 12 34 56 78)";
        }

        if (!job?.trim()) newErrors.job = "Le rôle est obligatoire";

        // Image obligatoire si création
        if (!trombi && !id_image) newErrors.id_image = "Une image est requise";

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
        };
	// const [description, setDescription] = useState("");
	return (
	<Modal
        show={true}
        onHide={onClose}
        size={"lg"}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Création de trombinoscope
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
			<label htmlFor="lastname">Nom</label>
                <input
                    type={"text" }
                    className="form-control m-2"
                    id="lastname"
                    value={last_name}
                    onChange={(e)=>setLastname(e.target.value)}
                    name="lastname"
                />
                {errors.last_name && <div className="text-danger small mt-1">{errors.last_name}</div>}
			<label htmlFor="firstname">Prénom</label>
                <input
                    type={"text" }
                    className="form-control m-2"
                    id="firstname"
                    value={first_name}
                    onChange={(e)=>setFirstname(e.target.value)}
                    name="firstname"
                />
                {errors.first_name && <div className="text-danger small mt-1">{errors.first_name}</div>}
			<label htmlFor="email">Adresse email</label>
                <input
                        type={"text" }
                        className="form-control m-2"
                        id="email"
                        value={email}
                        onChange={(e)=>setEmail(e.target.value)}
                        name="email"
                    />
                    {errors.email && <div className="text-danger small mt-1">{errors.email}</div>}
			<label htmlFor="phone">Numéro de téléphone</label>
                <input
                    type={"tel" }
                    className="form-control m-2"
                    id="phone"
                    pattern="[0-9]{2}-[0-9]{2}-[0-9]{2}-[0-9]{2}-[0-9]{2}"
                    value={phone}
                    onChange={(e)=>setPhone(e.target.value)}
                    name="phone"
                />
                {errors.phone && <div className="text-danger small mt-1">{errors.phone}</div>}
            <label htmlFor="job">Rôle</label>
                <input
                    type={"text" }
                    className="form-control m-2"
                    id="job"
                    value={job}
                    onChange={(e)=>setJob(e.target.value)}
                    name="job"
                />
                {errors.job && <div className="text-danger small mt-1">{errors.job}</div>}
			<div class="mb-3">
				<label for="formFile" class="form-label">Choisissez une image :</label>
				{id_image !== null && <p for="formFile" class="form-label text-danger">Ajouter une image remplacera la précédente</p>}
				<input class={(id_image !== null)?"form-control bg-success":"form-control"} type="file" id="formFile" onChange={(e)=>{
					const file = e.target.files[0];
					if (!file) return;
                    setExtension(file.type.replace("image/",""));

					const reader = new FileReader();
					reader.onloadend = () => {
						setId_image(reader.result);
					};

					reader.readAsDataURL(file);
					}}/>
                {errors.id_image && <div className="text-danger small mt-1">{errors.id_image}</div>}
			</div>
			
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Annuler
          </Button>
		  <Button
            variant="primary"
            disabled={!isFormComplete}
            onClick={()=>{if (!validate()) return;onAdd({first_name:first_name,last_name:last_name,email:email,phone:phone,job:job,id_image:id_image,extension:extension})}}
          >
            Ajouter
          </Button>
        </Modal.Footer>
      </Modal>
    );
}	
function ContactAdmin(){
    const [modalOpen, setModalOpen] = useState(null);
    const [membersList, setMembersList] = useState([]);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    useEffect(() => {
            API.getAllTrombinoscopeRequest(
                (response)=>{
                    setMembersList(response.data);
                },
                ()=>{
                }
                )
            },
            []
            );

    const addTrombinoscope = (data) => {API.createTrombinoscopeRequest(data,()=>{API.getAllTrombinoscopeRequest((response)=>{setMembersList(response.data);setSuccess("Membre ajoute avec succes.");closeModal();},(data)=>{closeModal();})},(data)=>{setError(data);})};
	const removeTrombinoscope = (id)=>{API.removeTrombinoscopeRequest({data:id},()=> API.getAllTrombinoscopeRequest((response)=>{setMembersList(response.data)},()=>{}),()=>{})}
    const openAddModal = () => setModalOpen(<MyModal onClose={closeModal} onAdd={addTrombinoscope}/>);
	const closeModal = () => setModalOpen(null);

    return (
    <>
        <HeaderHomeAdmin />

        <div className="container py-5">
        <h2 className="text-center fw-bold mb-5">
            Trombinoscope
        </h2>

        <button className="btn btn-primary mb-4" onClick={openAddModal}>
            ➕ Ajouter un membre
        </button>

        <Trombinoscope members={membersList} onDelete={removeTrombinoscope} />

        <hr className="my-5" />

        <AdhesionForm onSubmit={(data) => API.createAdhesionRequest(data,()=>{setSuccess("Adhesion ajoutee avec succes.");},(err)=>{setError(err);})} />
        </div>
        {modalOpen}
        <ErrorModal
            show={!!error}
            message={error}
            onClose={() => setError(null)}
        />
        <SuccessToast
            show={!!success}
            message={success}
            onClose={() => setSuccess(null)}
        />
        <Footer />
    </>
    );
}
export default ContactAdmin;
